import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';
import { Widget } from '../query-definitions/system.graphql';

export interface CreateWidgetMutationResponse {
  createWidget: {
    code: String;
    success: Boolean;
    message: String;
    widget: Widget;
  };
}

@Injectable({
  providedIn: 'root',
})
export class CreateWidget extends Mutation<CreateWidgetMutationResponse> {
  document = gql(`
  mutation createWidget($input: ModelWidgetsFilterInput) {
    createWidget(input: $input) {
      code
      success
      message
      widget {
        uid
        name
        description
        url
        type
      }
    }
  }
  `);
}

export interface FileUploadResponse {
  insertUserWidget: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class FileUpload extends Mutation<FileUploadResponse> {
  document = gql(`
    mutation fileUpload($bucket: String, $directory: String, $extension: String, $identifier: String, $payload: String, $imageUpload: Boolean) {
      fileUpload(bucket: $bucket, directory: $directory, extension: $extension, identifier: $identifier, payload: $payload, imageUpload: $imageUpload) {
        code
        message
      }
    }
  `);
}

export interface InsertSharedImportProfileResponse {
  insertSharedImportProfile: {
    code: String;
    success: Boolean;
    message: String;
    sharedImportProfile: {
      uid: string;
      import_profile_id: number;
      ftp_user: string;
    };
  };
}

export interface InsertSharedImportProfileInput {
  importProfileUid: string;
  ftpUser: string;
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class InsertSharedImportProfileGQL extends Mutation<
  InsertSharedImportProfileResponse,
  InsertSharedImportProfileInput
> {
  document = gql(`
    mutation insertSharedImportProfile($importProfileUid: String! $ftpUser: String!, $type: String) {
      insertSharedImportProfile(importProfileUid: $importProfileUid, ftpUser: $ftpUser, type: $type) {
        code
        message
        sharedImportProfile {
          uid
          import_profile_id
          ftp_user
          type
        }
      }
    }
  `);
}

export interface UpdateSharedImportProfileResponse {
  updateSharedImportProfiles: {
    code: string;
    success: boolean;
    message: string;
  };
}

export interface UpdateSharedImportProfileInput {
  uid: string;
  importProfileUid: string;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateSharedImportProfileGQL extends Mutation<
  UpdateSharedImportProfileResponse,
  UpdateSharedImportProfileInput
> {
  document = gql(`
    mutation updateSharedImportProfile($uid: String!, $importProfileUid: String!) {
      updateSharedImportProfile(uid: $uid, importProfileUid: $importProfileUid) {
        code
        success
        message
      }
    }
  `);
}

export interface DeleteSharedImportProfileResponse {
  deleteSharedImportProfile: {
    code: string;
    success: boolean;
    message: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DeleteSharedImportProfileGQL extends Mutation<DeleteSharedImportProfileResponse, { uid: string }> {
  document = gql(`
    mutation deleteSharedImportProfile($uid: ID!) {
      deleteSharedImportProfile(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

export interface CreateSecretResponse {
  createSecret: {
    code: String;
    success: Boolean;
    message: String;
    secret: any;
  };
}

@Injectable({
  providedIn: 'root',
})
export class CreateSecret extends Mutation<CreateSecretResponse> {
  document = gql(`
    mutation createSecret($data: ModelSecretInput) {
      createSecret(data: $data) {
        code
        message
        secret {
          userName
          password
        }
      }
    }
  `);
}

export interface UpdateSecretResponse {
  updateSecret: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class UpdateSecret extends Mutation<UpdateSecretResponse> {
  document = gql(`
    mutation updateSecret($data: ModelSecretInput) {
      updateSecret(data: $data) {
        code
        message
      }
    }
  `);
}

export interface DeleteSecretResponse {
  deleteSecret: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DeleteSecret extends Mutation<DeleteSecretResponse> {
  document = gql(`
    mutation deleteSecret($data: ModelSecretInput) {
      deleteSecret(data: $data) {
        code
        message
      }
    }
  `);
}

export interface CreateSupportTicketResponse {
  createSupportTicket: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class CreateSupportTicket extends Mutation<CreateSupportTicketResponse> {
  document = gql(`
    mutation createSupportTicket($input: ModelCreateSupportInput) {
      createSupportTicket(input: $input) {
        code
        message
        success
      }
    }
  `);
}

export interface UpdateGlobalSettingResponse {
  updateGlobalSetting: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class UpdateGlobalSettingGQL extends Mutation<UpdateGlobalSettingResponse> {
  document = gql(`
    mutation updateGlobalSettingValue($input: ModelGlobalSettingValueUpdateInput) {
      updateGlobalSettingValue(input: $input) {
        code
        message
        success
      }
    }
  `);
}
